import { TApplicationState } from '../../types/redux';

export function getIsFlatViewOrderEnabled(state: TApplicationState): boolean {
  return Boolean(state.newbuilding?.flatViewOrder?.isEnabled);
}
